import axios from "@/config/axios";

const initiateState = () => {
    return {
        allRules: [],
        addRuleStatus: false,
        ruleById: null,
        updateRuleStatus: false,
        ruleExportStatus: false,
        removeRuleStatus: false,
        getUpdateStatus: false
    };
};

const state = initiateState();

const getters = {
    getAllRules: (state) => state.allRules,
    getRuleCreationStatus: (state) => state.addRuleStatus,
    getRuleDetails: (state) => state.ruleById,
    getRuleUpdateStatus: (state) => state.updateRuleStatus,
    getRuleExportStatus: (state) => state.ruleExportStatus,
    getRuleRemoveStatus: (state) => state.removeRuleStatus,
    getUpdateStatus: (state) => state.updateRuleStatus
};

const mutations = {
    setRules(state, data) {
        state.allRules = data;
    },
    setAddRuleStatus(state, status) {
        state.addRuleStatus = status;
    },
    setRuleDetails(state, data) {
        state.ruleById = data;
    },
    setUpdateRuleStatus(state, status) {
        state.updateRuleStatus = status;
    },
    setExportRuleStatus(state, status) {
        state.ruleExportStatus = status;
    },
    setRemoveRuleStatus(state, status) {
        state.removeRuleStatus = status;
    },
    setUpdateStatus(state, status) {
        state.updateRuleStatus = status;
    },
    reset(state) {
        const initial = initiateState();
        Object.keys(initial).forEach((key) => {
            state[key] = initial[key];
        });
    }
};

const actions = {
    fetchAllRules: async ({ commit, dispatch }, params) => {
        try {
            await dispatch("errors/clear", [], { root: true });
            const response = await axios.get("billing-rules", { params });
            commit("setRules", response.data);
        } catch (error) {
            if (error.response) {
                await dispatch("errors/errorResponse", error.response, { root: true });
            }
        }
    },

    createRule: async ({ commit, dispatch }, payload) => {
        try {
            await dispatch("errors/clear", [], { root: true });
            commit("setAddRuleStatus", false);
            await axios.post("billing-rules", payload);
            commit("setAddRuleStatus", true);
        } catch (error) {
            commit("setAddRuleStatus", false);
            if (error.response) {
                await dispatch("errors/errorResponse", error.response, { root: true });
            }
        }
    },

    getRuleById: async ({ commit, dispatch }, ruleId) => {
        try {
            await dispatch("errors/clear", [], { root: true });
            const response = await axios.get(`rule-book/${ruleId}`);
            commit("setRuleDetails", response.data);
        } catch (error) {
            if (error.response) {
                await dispatch("errors/errorResponse", error.response, { root: true });
            }
        }
    },

    updateRule: async ({ commit, dispatch }, { ruleData }) => {
        try {
            await dispatch("errors/clear", [], { root: true });
            commit("setUpdateRuleStatus", false);

            await axios.patch(`billing-rules`, ruleData);

            commit("setUpdateRuleStatus", true);
        } catch (error) {
            commit("setUpdateRuleStatus", false);
            if (error.response) {
                await dispatch("errors/errorResponse", error.response, { root: true });
            }
        }
    },


    exportRules: async ({ commit, dispatch }, params) => {
        try {
            await dispatch("errors/clear", [], { root: true });
            commit("setExportRuleStatus", false);
            const response = await axios.get("rules/download-as-csv", { params, responseType: 'blob' });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "RuleBook.csv");
            document.body.appendChild(link);
            link.click();
            commit("setExportRuleStatus", true);
        } catch (error) {
            commit("setExportRuleStatus", false);
            if (error.response) {
                await dispatch("errors/errorResponse", error.response, { root: true });
            }
        }
    },
    updateStatus: async ({ commit, dispatch }, params) => {
        try {
            await dispatch("errors/clear", [], { root: true });
            commit("setUpdateStatus", false);
            await axios.patch(`/rules/${params.id}/status`, {
                status: params.status,
            }); 
            commit("setUpdateStatus", true);
        } catch (error) {
            commit("setUpdateStatus", false);
            if (error.response) {
                await dispatch("errors/errorResponse", error.response, { root: true });
            }
        }
    },

    removeRule: async ({ commit, dispatch }, ruleId) => {
        try {
            await dispatch("errors/clear", [], { root: true });
            commit("setRemoveRuleStatus", false);
            await axios.delete(`billing-rules/${ruleId}`);
            commit("setRemoveRuleStatus", true);
        } catch (error) {
            commit("setRemoveRuleStatus", false);
            if (error.response) {
                await dispatch("errors/errorResponse", error.response, { root: true });
            }
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
